import CustomStore from "devextreme/data/custom_store";
import useApiConfiguration from "../apiConfig";
import { MezziApi } from "../data/apis";
import { useMemo } from "react";

export function useMezzoDataSource(personaleId: number) {
    const apiConfiguration = useApiConfiguration();

    const dataSource = useMemo(() => {
        const api = new MezziApi(apiConfiguration);

        return new CustomStore({
            key: 'idMezzo',
            loadMode: 'raw',
            load: (loadOptions) => {
                return api.getMezzi({
                    idPersonale: personaleId
                });
            }
        })
    }, [personaleId]);

    return dataSource;
}